export const DAASPHONE = '15225298'
export const callLink = (tel?: string) => `tel:${tel}`
